
import Vue from "vue";
import Component from "vue-class-component"; // 导入组件装饰器
import { getAuthorization } from "@/api/common";
import { formatDate } from "@/api/tools"; //导入相关工具
import { downloadFile } from "@/utils/index";
import { MarketReportApi } from "@/api/marketReportApi"; //导入配套接口API
import {
  exportReportUserDownLoadLoApi,
  getReportDownLoadListByPageApi,
  getReportFileByTypeIdApi,
} from "@/api/userEnrollInfo";
import { GetByPageData } from "@/models/marketReport/marketReportData"; //导入配套数据定义Model
// import OSS from "ali-oss";

@Component({
  components: {},
  filters: {
    //过滤器格式化时间
    myFormatDate: function (time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    //从路径中获取文件名
    getFileName: function (path) {
      var obj = path.lastIndexOf("/");
      return path.substr(obj + 1);
    },
  },
}) // Component装饰器装饰类
export default class MarketExportRecord extends Vue {
  // --------------------------------------------------------------数据区--------------------------------------------------------------
  name = "";
  $refs: Vue["$refs"] & {
    upload: any;
  };
  typeId: any = "";
  typeName: any = "";
  downloadNumber = 0;
  downloadUserNumber = 0;
  tableloading = false;

  // 获取接口API
  marketReport: MarketReportApi = new MarketReportApi();
  // 列表数据-查询参数
  queryForm: any = {
    reportIds: "",
    // 0-下载次数；1-下载人数
    queryDownLoadType: 0,
    currentPageIndex: 1,
    pageSize: 20,
  };
  // 列表数据-查询结果数据格式
  getByPageData: GetByPageData = new GetByPageData();
  //列表数据-查询结果数据格式-数据部分

  // --------------------------------------------------------------方法区----------------------------------------------------------------
  // 生命周期钩子
  created() {
    this.typeName = this.$route.params.name;
    this.typeId = this.$route.params.id;
    if (this.typeId) {
      this.queryForm.reportIds = [this.typeId];
    }
    this.onQuery();
    // this.getReportFileByTypeId();
  }
  getReportFileByTypeId() {
    getReportFileByTypeIdApi({ typeId: this.typeId })
      .then((res: any) => {
        if (res.data) {
          if (res.data.result.length !== 0) {
            this.queryForm.reportIds = res.data.result.map((m) => m.id);
            this.onQuery();
          }
        }
      })
      .catch(() => {
        this.tableloading = false;
      });
  }
  // 单个导出下载记录
  onSingleExportRecord() {
    let data = {
      reportIdList: [this.queryForm.reportIds.join(",")],
      queryDownLoadType: this.queryForm.queryDownLoadType,
    };
    this.marketReport.exportDownloadRecord(data).then((res: any) => {
      downloadFile(res, this.typeName);
    });
  }
  // 报告列表数据加载
  onQuery() {
    this.tableloading = true;
    getReportDownLoadListByPageApi(this.queryForm)
      .then((res: any) => {
        if (res.data) {
          this.downloadNumber = res.data.dwTotal;
          this.downloadUserNumber = res.data.dwOfPeopleTotal;
          this.getByPageData.tableData = res.data.pageData.data;
          this.getByPageData.total = res.data.pageData.total;
          this.$message({
            showClose: true,
            message: "查询成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: "查询失败",
            type: "error",
          });
        }
        this.tableloading = false;
      })
      .catch((error: any) => {
        this.tableloading = false;
      });
  }
  onSearch() {
    this.queryForm.currentPageIndex = 1;
    this.onQuery();
  }
  // 报告列表分页页容量变化事件
  onPageSizeChange(val) {
    this.queryForm.pageSize = val;
    this.queryForm.currentPageIndex = 1;
    this.onQuery();
  }
  // 报告列表分页页码变化事件
  onPageIndexChange(val) {
    this.queryForm.currentPageIndex = val;
    this.onQuery();
  }
  //格式化日期
  formatDate(time) {
    if (time == "") {
      return "";
    }
    let date = new Date(time);
    return formatDate(date, "yyyy-MM-dd hh:mm:ss");
  }
}
